import {Component, HostBinding, Input, OnInit, Output} from '@angular/core';
import {NavItem} from '../../../model/component/nav-item';
import {Router} from '@angular/router';
import {NavigationService} from '../../../service/navigation/navigation.service';
import {BundeslandFilterService} from '../../../service/bundeslandFilter/bundesland-filter.service';

@Component({
  selector: 'app-nav-list-item',
  templateUrl: './nav-list-item.component.html',
  styleUrls: ['./nav-list-item.component.css', '../sidenav.component.css']
})
export class NavListItemComponent implements OnInit {

  expanded: boolean = true;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;

  @Input()
  public item: NavItem;
  @Input()
  public depth: number;

  constructor(public router: Router, public navService: NavigationService, private bundeslandFilterService: BundeslandFilterService) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnInit() {
    this.bundeslandFilterService.onFilterUpdated.subscribe(bundeslaender => {
      if (this.bundeslandFilterService.selectedBundesLand !== undefined &&
        this.bundeslandFilterService.selectedBundesLand.name === 'Europa') {
        this.item.disabled = false;
      }
    });
    this.navService.currentUrl.subscribe((url: string) => {
      if (this.item.route && url) {
        this.expanded = url.indexOf(`/${this.item.route}`) === 0;
        this.ariaExpanded = this.expanded;
      }
    });
  }

  public onItemSelected(item: NavItem) {
    item.selected = true;
    if (item.children === undefined || item.children.length === 0) {
      this.navService.onNavigationItemClick.emit(true);
      // localStorage.setItem('currentRoute', item.route);
      this.router.navigate([item.route]);
      this.expanded = false;
    } else if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
  }
}
